import RunActionEveryField from "./components/RunActionEveryField.js";
import DisableActionField from "./components/DisableActionField.js";
import { FormLayout } from "@shopify/polaris";
import DateField from "./components/DateField.js";
import TimeField from "../TimeField/TimeField.js";

const EveryPeriodSettings = ({ input }) => {
  return (
    <FormLayout>
      <RunActionEveryField input={input} />
      <DisableActionField input={input} />
      <DateField input={input} />
      <TimeField input={input} />
    </FormLayout>
  );
};

export default EveryPeriodSettings;